/**
 * @file CardShow/constants.js
 * @copyright 2016 CBC/Radio-Canada. All rights reserved.
 */

export const SRCSET_IMAGE_BREAKPOINTS = [
    `(max-width: 560px) 70vw`,
    `(max-width: 960px) 40vw`,
    "300px",
];
